export const DISHOP_INFO = {
  companyName: 'Dishop',
  address: {
    city: 'Nice',
    country: 'France',
    postalCode: '06000',
    streetNumber: '38',
    street: 'bis Boulevard Victor Hugo'
  },
  email: 'contact@dishop.co',
  tvaNumber: 'FR24879912806'
};

export const EMPTY_DESIGN_STOCK_TITLE = "Vous n'avez pas encore réalisé de ventes. ";
export const EMPTY_DESIGN_STOCK_TEXT = `Vous devez d'abord créer vos produits. Ensuite, vous pourrez commencer à les vendre ! 
Rendez-vous dans l'onglet "Produits".`;
export const EMPTY_DESIGN_OPTIONS_TITLE = "Vous n'avez pas encore créé de listes d'options.";
export const EMPTY_DESIGN_OPTIONS_TEXT =
  "Commencez à créer vos listes d'options pour présenter vos produits !";
export const EMPTY_DESIGN_ORDERS_TITLE = "Vous n'avez pas encore reçu de commandes.";
export const EMPTY_DESIGN_ORDERS_TEXT =
  'Dès que vous recevrez de nouvelles commandes, elles apparaîtront ici ! ';
export const EMPTY_DESIGN_DRIVER_TITLE = "Aucun livreur salarié n'est enregistré pour le moment.";
export const EMPTY_DESIGN_DRIVER_TEXT =
  "Demandez à vos livreurs salariés de télécharger l'application Dishop Fleet !";
export const EMPTY_DESIGN_FREELANCE_DRIVER_TITLE =
  "Aucun livreur indépendant n'est enregistré pour le moment.";
export const EMPTY_DESIGN_FREELANCE_DRIVER_TEXT =
  "Demandez aux livreurs indépendants de télécharger l'application Dishop Fleet !";
export const EMPTY_DESIGN_PROMOS_TITLE = "Vous n'avez pas encore créé de codes promotionnels.";
export const EMPTY_DESIGN_PROMOS_TEXT =
  'Créez vos codes promotionnels et partagez-les avec vos clients ! ';
export const EMPTY_DESIGN_SUPPORT_TITLE = "Il n'y a aucune réclamation client en cours.";
export const EMPTY_DESIGN_SUPPORT_TEXT = 'Toutes vos demandes de support client apparaîtront ici.';
export const EMPTY_DESIGN_CLIENTS_TITLE =
  "Il n'y a pas encore de clients enregistrés pour ce magasin.";
export const EMPTY_DESIGN_CLIENTS_TEXT = 'Tous vos clients apparaîtront ici ! ';
export const EMPTY_DESIGN_PRODUCTS_TITLE = "Vous n'avez pas encore créé de produits.";
export const EMPTY_DESIGN_PRODUCTS_TEXT =
  'Rentrez ici tous vos produits pour commencer à les vendre !';
export const EMPTY_DESIGN_PUSH_NOTIF_TITLE = "Vous n'avez pas encore envoyé de Push Notifications.";
export const EMPTY_DESIGN_PUSH_NOTIF_TEXT =
  'Envoyez votre première Push Notification à vos clients.';
export const MISSED_SHOP_INFO = {
  title:
    'Certaines informations concernant votre entreprise et votre magasin n’ont pas encore été complétées',
  buttonText: 'Compléter mes informations manquantes'
};
export const MISSED_PAYMENT_INFO = {
  title: 'Vos informations bancaires n’ont pas encore été complétées',
  buttonText: 'Compléter mes informations bancaires'
};
export const MISSED_STRIPE_INFO = {
  title:
    'Certaines informations n’ont pas encore été complétées sur la plateforme de notre partenaire de paiement Stripe',
  buttonText: 'Terminer ma configuration Stripe'
};
export const EMPTY_DESIGN_SCHEDULED_PUSH_NOTIF_TITLE = "Programmez des notifications automatiques ";
export const EMPTY_DESIGN_SCHEDULED_PUSH_NOTIF_TEXT = "Prenez de l'avance, elles s'enverront automatiquement !"
export const EMPTY_DEEPLINKS_TITLE = "Aucun lien magique n'a encore été créé.";

